import layout from '@/views/layout/layout.vue'
const marketingImagesList = r => require.ensure([], () => r(require('@/views/marketing/marketingImages/list.vue')), 'group-marketing-marketingImages')

const marketingImagesConfig = [
  {
    path: '/marketing/marketingImages',
    name: 'marketing-marketingImages',
    component: layout,
    redirect: '/marketing/marketingImages/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: marketingImagesList,
        name: 'marketing-marketingImages-list',
        meta: {
          displayName: '金冠拍照明细',
          requireAuth: true
        }
      }
    ]
  }
]

export default marketingImagesConfig



// WEBPACK FOOTER //
// ./src/router/marketing/marketingImages.js